import { ca } from '@cian/analytics';

export function trackStickyHeaderTabClick(label: string): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_CW',
    action: 'click_tab',
    label,
    useLastProducts: true,
  });
}
